module.exports = __webpack_public_path__ + "img/주거산업.3e3eb34d.png";